/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_How_To_Play_DescriptionInputs */



/**
* | output |
* | --- |
* | "A short visual primer on the rules: how to win, what's in your deck, how a turn flows, and how battlefields are fought over." |
*
* @param {Help_Article_How_To_Play_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_how_to_play_description = /** @type {((inputs?: Help_Article_How_To_Play_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_How_To_Play_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine kurze bebilderte Einführung in die Regeln: wie du gewinnst, was in deinem Deck steckt, wie ein Zug abläuft und wie um Schlachtfelder gekämpft wird.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une courte introduction illustrée aux règles : comment gagner, ce que contient votre deck, comment se déroule un tour et comment on se dispute les champs de bataille.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("一份简短的图解规则入门：如何取胜、卡组里有什么、一个回合怎么进行，以及战场是怎么争夺的。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("圖解規則入門：如何獲勝、牌組裡有什麼、一個回合怎麼進行，以及戰場如何爭奪。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("규칙을 그림으로 짧게 정리했습니다. 승리 조건, 덱 구성, 턴 진행, 전장을 두고 벌이는 싸움을 다룹니다.")
	return /** @type {LocalizedString} */ ("A short visual primer on the rules: how to win, what's in your deck, how a turn flows, and how battlefields are fought over.")
});